export default /* html */ `
<ui-page>
  <ui-page-body>
    <ui-page-content>
      <ui-heading class="heading" type="h1">About me</ui-heading>
      <ui-card>
        <ui-card-content>
          <p class="intro">
            Developer with over 15 years of experience in designing, developing, and optimizing web applications — ranging from interactive portals to complex enterprise solutions. Skilled in both <span class="keyword">frontend</span> and <span class="keyword">backend</span> development, with in-depth knowledge of <span class="keyword">JavaScript, TypeScript</span>,
            and modern frameworks such as <span class="keyword">React</span>, <span class="keyword">Angular</span>, <span class="keyword">Vue</span>, <span class="keyword">Next.js</span>, and <span class="keyword">NestJS</span>.
          </p>
        </ui-card-content>
      </ui-card>
      <div class="content">
        <p>
          Started out as a graphic designer, which gave me a sharp eye for user-friendly design and pixel-perfect implementations. Over the years, I've grown into a full-stack developer with extensive experience in building scalable applications, integrating APIs, and setting up CI/CD pipelines.
          <br/><br/>
          Curious and eager to learn, I'm constantly expanding my technical expertise — for example, by writing articles on Medium about topics that interest me and about personal projects. These range from web technologies (e.g. building my own frontend framework or component library) to low-level programming in C and Assembly (e.g. parsers, compression algorithms, and HTTP servers).
        </p>
        <div class="socials">
          <a href="https://www.linkedin.com/in/vincent-corbee-26856051/"><ui-icon icon="open_in_new"></ui-icon> <span>LinkedIn</span></a>
          <a href="https://medium.com/@vincentcorbee"><ui-icon icon="open_in_new"></ui-icon> <span>Medium</span></a>
          <a href="https://github.com/vincentcorbee"><ui-icon icon="open_in_new"></ui-icon> <span>GitHub</span></a>
        </div>
        </div>
    </ui-page-content>
  </ui-page-body>
</ui-page>
`
